import React from 'react';

import { Typography } from '@mui/material';
import { IElementTitle } from './IElementTitle';
export default function ElementTitle({ title }: IElementTitle) {
    return (
        <div>
            <Typography
                sx={{ fontSize: '14px', marginRight: '10px' }}
                className="text-[var(--primary-text-color)] !mt-3"
            >
                {title}
            </Typography>
        </div>
    );
}
